import {isMobileViewport} from '../lib/utilities.js';

class Timeline {
  constructor(element) {
    this.element = element;
    this.blocks = this.element.querySelectorAll('[data-element="timeline-block"]');
    this.buttons = this.element.querySelectorAll('[data-element="timeline-button"]');
    this.contents = this.element.querySelectorAll('[data-element="timeline-content"]');
    this.firstBlock = this.blocks[0];
    this.firstContent = this.contents[0];
    this.lastBlock = this.blocks[this.blocks.length - 1];
    this.lastContent = this.contents[this.contents.length - 1];
  }

  init() {
    this.setFirstBlockOpen();
    this.blocks.forEach((block) => {
      block.addEventListener('keydown', this.onKeydown.bind(this));
    });
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this, button));
    });
  }

  onButtonClick(button) {
    const block = button.closest('[data-element="timeline-block"]');

    if (isMobileViewport()) {
      console.log(isMobileViewport(), block.classList.contains('timeline__block--open'));
      if (false === block.classList.contains('timeline__block--open')) {
        this.closeAllBlocks();
        block.classList.add('timeline__block--open');
        block.setAttribute('aria-expanded', true);
        block.setAttribute('aria-selected', true);
        block.setAttribute('tabindex', 0);
        this.element.querySelector('[data-element="timeline-content"][data-index="' + button.dataset.index + '"]').classList.add('timeline__content--show');
      } else {
        this.closeAllBlocks();
      }
    } else {
      this.closeAllBlocks();
      block.classList.add('timeline__block--open');
      block.setAttribute('aria-expanded', true);
      block.setAttribute('aria-selected', true);
      block.setAttribute('tabindex', 0);
      this.element.querySelector('[data-element="timeline-content"][data-index="' + button.dataset.index + '"]').classList.add('timeline__content--show');
    }

    if (isMobileViewport()) {
      button.scrollIntoView();
    } else {
      this.element.closest('section').scrollIntoView();
    }
  }

  onKeydown(event) {
    const currentBlock = event.currentTarget;
    let flag = false;

    switch (event.key) {
    case 'ArrowUp':
    case 'ArrowLeft':
      this.moveFocusToPreviousBlock(currentBlock);
      flag = true;
      break;

    case 'ArrowDown':
    case 'ArrowRight':
      this.moveFocusToNextBlock(currentBlock);
      flag = true;
      break;

    case 'Home':
      this.moveFocusToBlock(this.firstBlock);
      flag = true;
      break;

    case 'End':
      this.moveFocusToBlock(this.lastBlock);
      flag = true;
      break;

    default:
      break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  moveFocusToBlock(currentBlock) {
    currentBlock.querySelector('[data-element="timeline-button"]').focus();
  }

  moveFocusToPreviousBlock(currentBlock) {
    if (currentBlock === this.firstBlock) {
      this.moveFocusToBlock(this.lastBlock);
    } else {
      this.moveFocusToBlock(currentBlock.previousElementSibling);
    }
  }

  moveFocusToNextBlock(currentBlock) {
    if (currentBlock === this.lastBlock) {
      this.moveFocusToBlock(this.firstBlock);
    } else {
      this.moveFocusToBlock(currentBlock.nextElementSibling);
    }
  }

  setFirstBlockOpen() {
    this.firstBlock.classList.add('timeline__block--open');
    this.firstBlock.setAttribute('aria-expanded', true);
    this.firstBlock.setAttribute('aria-selected', true);
    this.firstBlock.setAttribute('tabindex', 0);
    this.firstContent.classList.add('timeline__content--show');
  }

  closeAllBlocks() {
    this.blocks.forEach((block) => {
      block.classList.remove('timeline__block--open');
      block.setAttribute('aria-expanded', false);
      block.setAttribute('aria-selected', false);
      block.setAttribute('tabindex', -1);
    });
    this.contents.forEach((content) => {
      content.classList.remove('timeline__content--show');
    });
  }
}

const timeline = {
  init() {
    const timelineItems = document.querySelectorAll('[data-module="timeline"]');

    if (timelineItems && timelineItems.length > 0) {
      timelineItems.forEach((item) => {
        const timelineItem = new Timeline(item);
        timelineItem.init();
      });
    }
  },
};

export default timeline;
